import { QueryClient, useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiErrorResponse, KPIRequest } from "../models/ApiResponse";
import { apiStore } from "../stores/api.store";
import { toast } from "../utils/toast";

export const queryClient = new QueryClient();

type QueryOpts = {
	enabled?: boolean;
	refetchInterval?: number;
};

export function useKPIDashboard(callback = (response: any) => {}) {
	const queryClient = useQueryClient();

	return useMutation<any, ApiErrorResponse, KPIRequest>(
		(params) =>
			apiStore
				.get({
					path: `/dashboard`,
					isAuthRequired: true,
					query: params as any,
				})
				.then((d: any) => d.data),

		{
			onSuccess: (data, params) => {
				callback(data);
				queryClient.invalidateQueries(["dashboard", params]);
			},
			onError: ({ error }) => {
				toast.apiError(error.code);
			},
		}
	);
}

export function useRefreshDashboardCache() {
	const queryClient = useQueryClient();

	return useMutation<any, ApiErrorResponse, { clear?: boolean } | void>(
		(params) => {
			const clear = !!(params && (params as any).clear);
			return apiStore
				.post({
					path: `/dashboard/refresh-cache${clear ? "?clear=true" : ""}`,
					isAuthRequired: true,
					body: {},
				})
				.then((d: any) => d.data);
		},

		{
			onSuccess: () => {
				queryClient.invalidateQueries(["dashboard"]);
			},
			onError: ({ error }) => {
				toast.apiError(error.code);
			},
		}
	);
}
